import { RefreshCw } from "lucide-react";
import { Button } from "./button";
import { cn } from "@/lib/utils";

interface UpdateNotificationProps {
  show: boolean;
  onUpdate: () => void;
}

// Sem botão de fechar (decisão do Diretor, I.150): a faixa só some quando a pessoa atualiza.
export function UpdateNotification({ show, onUpdate }: UpdateNotificationProps) {
  if (!show) return null;

  return (
    <div
      className={cn(
        "fixed bottom-4 left-4 right-4 z-[100] md:left-auto md:right-4 md:max-w-sm",
        "animate-in slide-in-from-bottom-4 fade-in duration-300"
      )}
    >
      <div className="bg-primary text-primary-foreground rounded-lg shadow-lg p-4 flex items-center gap-3">
        <RefreshCw className="h-5 w-5 flex-shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="font-medium text-sm">Nova versão disponível</p>
          <p className="text-xs opacity-90">Clique para atualizar o sistema</p>
        </div>
        <Button
          size="sm"
          variant="secondary"
          onClick={onUpdate}
          className="whitespace-nowrap"
        >
          Atualizar
        </Button>
      </div>
    </div>
  );
}

// Small badge indicator for when update is pending but dismissed
export function UpdatePendingBadge({ show, onClick }: { show: boolean; onClick: () => void }) {
  if (!show) return null;
  
  return (
    <button
      onClick={onClick}
      className={cn(
        "fixed bottom-4 right-4 z-[99]",
        "bg-primary text-primary-foreground rounded-full p-3 shadow-lg",
        "animate-pulse hover:animate-none transition-all",
        "hover:scale-110 active:scale-95"
      )}
      title="Nova versão disponível - Clique para atualizar"
    >
      <RefreshCw className="h-5 w-5" />
    </button>
  );
}
